
import { Component, Prop, Vue, Watch, Inject } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import pageheader from './pageheader.vue';
import announcement from './announcement.vue';
import imgnavigation from './imgnavigation.vue';
import hotzone from './hotzone.vue';
import shopmode from './shopmode.vue';
import videomode from './videomode.vue';
import search from './search.vue';
import specialzone from './specialzone.vue';
import dailypackage from './dailypackage.vue';
import menulist from "./menulist.vue"
import coupon from "./coupon.vue"
import InstantDeath from "./InstantDeath.vue"
import classifiedGoods from "./classifiedGoods.vue"



import Message from '@/components/message.vue';
@Component({
	name: '',
	components: {
		PageFooter,
		pageheader,
		announcement,
		imgnavigation,
		hotzone,
		shopmode,
		videomode,
		search,
		specialzone,
		dailypackage,
		menulist,
		coupon,
		InstantDeath,
		classifiedGoods,

		'slz-message': Message,
	}
})

export default class ProductList extends Vue {
	private info: any = {}
	private msgShow = false

	@Inject() information: any
	get value() {
		return this.information
	}
	@Inject() editinfo: any
	get editmsg() {
		return this.editinfo.msg
	}



	private confirmgo() {
		this.$router.push({
			name: 'customizepage'
		})
	}
	private test() {
		// if(this.information.length<2){
		//   this.$message.error('请设置装修模块')
		//   return
		// }
		for (let obj of this.information) {
			if (!obj.moduleName && obj.value != 0) {
				this.$message.error('请输入组件名称')
				return false
			}
			if (obj.value == 0) {
				if (!obj.content) {
					this.$message.error('请设置页面标题')
					return false
				}
			} else if (obj.value == 1) {
				if (!obj.content) {
					this.$message.error('请输入公告内容')
					return false
				}
			} else if (obj.value == 2) {
				if (!obj.imglist || !obj.imglist.length) {
					this.$message.error('请上传图片')
					return false
				} else {
					for (let img of obj.imglist) {
						if (!img.url) {
							this.$message.error('请上传图片')
							return false
						}
						if (new Date(img.startTime).getTime() > new Date(img.endTime).getTime()) {
							this.$message.error('请设置正确的显示时间')
							// console.log(img.startTime,img.endTime)
							return false
						}
					}
				}
			} else if (obj.value == 3) {
				if (!obj.img) {
					this.$message.error('请上传热区图片')
					return false
				} else if (!obj.imglist && !obj.imglist.length) {
					this.$message.error('请上传热区图片')
					return false
				}
			} else if (obj.value == 4) {
				// console.log(obj.list)
				if (!obj.list || !obj.list.length) {
					this.$message.error('还未添加商品')
					return false
				}
			} else if (obj.value == 5) {
				if (!obj.coverimg) {
					this.$message.error('请上传视频封面图')
					return false
				} else if (!obj.video) {
					this.$message.error('请上传视频')
					return false
				}
			} else if (obj.value == 7) {
				if (!obj.titleImg) {
					this.$message.error('请上传专区头部图片')
					return false
				} else if (!obj.subjectImg) {
					this.$message.error('请上传专区主题图片')
					return false
				} else if ((obj.showStartTime && !obj.showEndTime) || (obj.showEndTime && !obj.showStartTime)) {
					this.$message.error('请完善模块显示时间')
					return false
				} else if (new Date(obj.showStartTime).getTime() > new Date(obj.showEndTime).getTime()) {
					this.$message.error('结束时间不能早于开始时间')
					return false
				} else if (!obj.startTime || !obj.endTime) {
					this.$message.error('请选择活动时间')
					return false
				} else if (new Date(obj.startTime).getTime() > new Date(obj.endTime).getTime()) {
					this.$message.error('请选择正确的时间')
					return false
				} else if (!obj.link?.Id) {
					this.$message.error('请选择链接')
					return false
				}
			} else if (obj.value == 8) {
				let str = '';
				for (let k in obj.someDayData){
					obj.someDayData[k].map(item=>{
						if (!str) {
							if (item.type == 2) {
								if (!item.areaName){
									str = '请输入专区名称';
								}else if(!item.areaDesc){
									str = '请输入专区介绍';
								}else if(!item.link?.Id){
									str = '请选择链接';
								}else if(!item.start || !item.end){
									str = '请选择活动时间';
								}else if (new Date(item.start).getTime() > new Date(item.end).getTime()){
									str = '结束时间不能早于开始时间';
								}else if (!item.picture1 || !item.picture2){
									str = '请选择专区封面图';
								}else if (!item.products.length){
									str = '请添加专区商品';
								}
							}
						}
					})
				}

				if (str){
					this.$message.error(str)
					return false
				}
			} else if (obj.value == 9) {
				if (!obj.menuList || !obj.menuList.length) {
					this.$message.error('至少有一个定位菜单')
					return false
				}
				for (let menu of obj.menuList) {
					if (!menu.name) {
						this.$message.error('请输入菜单名称')
						return false
					}
					if ((menu.startTime && !menu.endTime) || (!menu.startTime && menu.endTime)) {
						this.$message.error('请完善定位菜单的显示时间')
						return false
					}
					if (menu.startTime && menu.endTime) {
						if (new Date(menu.startTime).getTime() > new Date(menu.endTime).getTime()) {
							this.$message.error('结束时间不能早于开始时间')
							return false
						}
					}
				}
			} else if (obj.value == 10) {
				if (!obj.list || !obj.list.length) {
					this.$message.error('请添加优惠券')
					return false
				}
			} else if (obj.value == 12) {
				if (!obj.list || !obj.list.length) {
					this.$message.error('请添加商品分类')
					return
				}
				for (let item of obj.list) {
					if (!item.name) {
						this.$message.error('请输入分类名称')
						return
					}
					if (!item.shopList || !item.shopList.length) {
						this.$message.error('请添加分类下的商品')
						return
					}
				}
			}
		}
		return true
	}
	private save(Isrelease) {
		if (!this.test()) return
		this.$emit('confirm', {
			type: 'save',
			Isrelease: Isrelease
		})
	}
	private preview() {
		if (!this.test()) return
		this.$emit('confirm', {
			type: 'preview',
		})
	}
}
